export const LearnPanel = {
  flow: 'y',
  fontSize: 'Z2',
  padding: 'A+Z Z2',
  gap: 'C',
  overflow: 'hidden auto',
  ExamplesInLearn: {},
  Line_1: {
    margin: '- -A',
  },
  TutorialsInLearn: {},
  Line_2: {
    margin: '- -A',
  },
  TutorialsPanel: {},
  Line_3: {
    margin: '- -A',
  },
  LibrariesInLearn: {},
};